import { api } from '../configs/apiConfig';

class NotificationService {
    constructor() {
        // No need for baseURL when using api object
    }

    // Get user's notifications with pagination
    async getUserNotifications(userId, page = 1, pageSize = 20) {
        try {
            const response = await api.get(`/notification/user/${userId}?page=${page}&pageSize=${pageSize}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching user notifications:', error);
            throw error;
        }
    }

    // Get unread notifications
    async getUnreadNotifications(userId, limit = 10) {
        try {
            const response = await api.get(`/notification/user/${userId}/unread?limit=${limit}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching unread notifications:', error);
            throw error;
        }
    }

    // Get notification summary (total and unread counts)
    async getNotificationSummary(userId) {
        try {
            const response = await api.get(`/notification/user/${userId}/summary`);
            return response.data;
        } catch (error) {
            console.error('Error fetching notification summary:', error);
            throw error;
        }
    }

    // Get specific notification by ID
    async getNotificationById(notificationId) {
        try {
            const response = await api.get(`/notification/${notificationId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching notification:', error);
            throw error;
        }
    }

    // Mark notification as read
    async markAsRead(notificationId) {
        try {
            const response = await api.put(`/notification/${notificationId}/mark-read`);
            return response.data;
        } catch (error) {
            console.error('Error marking notification as read:', error);
            throw error;
        }
    }

    // Mark all notifications as read
    async markAllAsRead(userId) {
        try {
            const response = await api.put(`/notification/user/${userId}/mark-all-read`);
            return response.data;
        } catch (error) {
            console.error('Error marking all notifications as read:', error);
            throw error;
        }
    }

    // Delete notification
    async deleteNotification(notificationId) {
        try {
            const response = await api.delete(`/notification/${notificationId}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting notification:', error);
            throw error;
        }
    }

    // Create notification (for testing or admin purposes)
    async createNotification(notificationData) {
        try {
            const response = await api.post(`/notification`, notificationData);
            return response.data;
        } catch (error) {
            console.error('Error creating notification:', error);
            throw error;
        }
    }

    // Format notification date
    formatNotificationDate(dateString) {
        const date = new Date(dateString);
        const now = new Date();
        const diffInMinutes = Math.floor((now - date) / (1000 * 60));

        if (diffInMinutes < 1) {
            return 'Just now';
        } else if (diffInMinutes < 60) {
            return `${diffInMinutes} minute${diffInMinutes > 1 ? 's' : ''} ago`;
        } else if (diffInMinutes < 1440) { // 24 hours
            const hours = Math.floor(diffInMinutes / 60);
            return `${hours} hour${hours > 1 ? 's' : ''} ago`;
        } else {
            const days = Math.floor(diffInMinutes / 1440);
            return `${days} day${days > 1 ? 's' : ''} ago`;
        }
    }

    // Get notification icon based on type
    getNotificationIcon(notificationType) {
        switch (notificationType) {
            case 'TaskAssigned':
                return '📋';
            case 'TaskCompleted':
                return '✅';
            case 'TaskRejected':
                return '❌';
            case 'TaskCancelled':
                return '🚫';
            case 'TaskEscalated':
                return '⬆️';
            default:
                return '🔔';
        }
    }

    // Get notification color based on type
    getNotificationColor(notificationType) {
        switch (notificationType) {
            case 'TaskAssigned':
                return 'primary';
            case 'TaskCompleted':
                return 'success';
            case 'TaskRejected':
                return 'danger';
            case 'TaskCancelled':
                return 'warning';
            case 'TaskEscalated':
                return 'info';
            default:
                return 'secondary';
        }
    }
}

export default new NotificationService(); 